/**
 * The accept and tie decisions the three local recovery steps share, over the
 * one `TextSimilarity` the whole redline code uses. Keeping the thresholds
 * here means the paragraph-id, neighbour-id and change-ledger steps cannot
 * drift apart in what they call "still the same paragraph".
 */
import { TextSimilarity } from "@common/utils/redline/text/text-similarity";

import type { RecoveryConfig } from "../recovery-config";

export class CandidateScorer {
    constructor(private readonly config: RecoveryConfig) {}

    /** 0..1, the shared similarity of a candidate paragraph's text to the text the redline last covered. */
    similarity(candidateText: string, anchoredText: string): number {
        return TextSimilarity.score(candidateText, anchoredText);
    }

    accepts(score: number): boolean {
        return score >= this.config.candidateSimilarity;
    }

    /** Two candidates this close cannot be told apart; the step reports ambiguity rather than guessing. */
    tied(bestScore: number, secondScore: number): boolean {
        return bestScore - secondScore < this.config.candidateMargin;
    }
}
